import { defineStore } from 'pinia';
import type { ObjectSchema } from 'yup';
import { object, string } from 'yup';
import type { FormSubmitEvent } from '#ui/types';
import type { ContactBody } from '~/types/contact';
import { LazyConfirmModal } from '#components';

export const useMyContactFormStore = defineStore('myContactFormStore', {
    state: (): ContactBody & { error: string; lock: boolean } => ({
        email: '',
        nom: '',
        prenom: '',
        mobile: '',
        question: '',
        message: '',
        error: '',
        lock: false
    }),
    actions: {
        async submit(event: FormSubmitEvent<ContactBody>) {
            try {
                this.lock = true;
                await new Promise(res => setTimeout(res, 500));
                await $fetch('/api/contact', { method: 'POST', body: event.data });
                this.$reset();
                this.lock = true;
                const modal = useModal();
                modal.open(LazyConfirmModal, {
                    title: 'Message envoyé',
                    description: 'Merci de nous avoir contacté, nous vous répondrons dans les plus brefs délais.',
                    confirmButton: "Retourner à la page d'accueil",
                    showBackButton: false,
                    dismissible: false,
                    confirmFunction: async () => {
                        await new Promise(res => setTimeout(res, 1000));
                        setTimeout(() => {
                            navigateTo('/', { replace: true });
                        }, 400);
                    }
                });
            } catch (e) {
                this.error = 'Une erreur est survenue';
                this.lock = true;
                console.log(e);
            } finally {
                console.log('done');
            }
        }
    },
    getters: {
        schema: (): ObjectSchema<ContactBody> =>
            object({
                prenom: string()
                    .matches(/^[A-Za-zÀ-ÖØ-öø-ÿ '-]*$/, 'Merci de saisir un prénom valide')
                    .max(40)

                    .required('Merci de saisir votre prénom '),
                nom: string()
                    .matches(/^[A-Za-zÀ-ÖØ-öø-ÿ '-]*$/, 'Merci de saisir un nom valide')
                    .max(40)
                    .min(2)
                    .required('Merci de saisir votre nom '),
                email: string().email('Invalid email').required('Merci de rentrer un email'),
                question: string().min(1, 'Merci de selectionner une question').required('Merci de selectionner une question'),
                mobile: string()
                    .matches(/^(?:\+(?:\d[\s.-]?){6,14}\d|0(?:[\s.-]?\d){7,12})?$/, 'Merci de saisir un numéro de téléphone valide')
                    .optional(),
                message: string().min(10).max(2000).required('Merci de taper votre message')
            })
    }
});
